import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-icons',
  templateUrl: './social-icons.component.html',
  styleUrls: ['./social-icons.component.scss'],
})
export class SocialIconsComponent {
  @Input() instagramUrl: string | null = null;
  @Input() facebookUrl: string | null = null;
  @Input() xUrl: string | null = null;
  @Input() linkedinUrl: string | null = null;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() variant: 'default' | 'minimal' = 'default';

  openSocialMedia(url: string): void {
    if (!url) return;

    let finalUrl = url.trim();
    if (!finalUrl.startsWith('http://') && !finalUrl.startsWith('https://')) {
      finalUrl = 'https://' + finalUrl;
    }

    window.open(finalUrl, '_blank', 'noopener,noreferrer');
  }
}
